import Pagination from './Pagination'

type Props = {
  currentPage: number
  totalCount: number
  pageUrl: (page: number) => string
  shouldNoFollow?: (page: number) => boolean
}

function PaginationContainer(props: Props) {
  const { currentPage, totalCount, pageUrl, shouldNoFollow } = props
  const totalPage = Math.ceil(totalCount / 10)

  return (
    <Pagination
      currentPage={currentPage}
      totalPage={totalPage}
      pageUrl={pageUrl}
      shouldNoFollow={shouldNoFollow}
    />
  )
}

export default PaginationContainer
